export default "__VITE_ASSET__D_60aVbB__"